const typePalettes = {
  danger: {
    className: "bg-danger text-white",
    icon: "fas fa-exclamation-circle",
  },
  warning: {
    className: "bg-warning text-white",
    icon: "fas fa-exclamation-triangle",
  },
  info: {
    className: "bg-white text-default",
    icon: "fas fa-info-circle",
  },
};

export default typePalettes;
